import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'
import { Row, Col } from 'react-flexbox-grid'
import Svg from 'components/util/Svg'
import Loader from 'components/util/Loader'
import styles from './_story.css'
import defaultImg from 'images/feed-default.png'
import RelativeDate from 'components/util/RelativeDate'
import StoryTitle from './StoryTitle'
import Highlight from './Highlight'
import LikeCopy from './LikeCopy'
import Comments from './Comments'

export class Story extends Component {
  static propTypes = {
    story: PropTypes.object,
    formatDistance: PropTypes.func,
    formatDuration: PropTypes.func,
    userId: PropTypes.number,
    onLike: PropTypes.func,
    onUnlike: PropTypes.func,
    onPostComment: PropTypes.func,
    onDeleteComment: PropTypes.func,
    onDeleteStory: PropTypes.func,
    onGetStoryComments: PropTypes.func,
  }

  state = {
    showComments: false,
    deleteStoryLoading: false,
  }

  componentWillMount () {
    const { story } = this.props
    const showComments = story.comments && story.comments.count > 0
    this.setState({
      showComments: showComments,
    })
  }

  handleLikeClick = () => {
    const { onLike, onUnlike, story } = this.props

    if (story.likes && story.likes.replied) {
      onUnlike(story)
    } else {
      onLike(story.id)
    }
  }

  handleCommentClick = () => {
    this.setState({
      showComments: !this.state.showComments,
    })
  }

  handlePostComment = (text) => {
    const { story, onPostComment } = this.props
    return onPostComment(text, story.id)
  }

  handleDeleteComment = (commentId) => {
    const { story, onDeleteComment } = this.props
    return onDeleteComment(commentId, story.id)
  }

  handleDeleteStory = () => {
    const { story, onDeleteStory } = this.props

    this.setState({ deleteStoryLoading: true })
    onDeleteStory(story.id).then(() => {
      this.setState({ deleteStoryLoading: false })
    }).catch(() => {
      this.setState({ deleteStoryLoading: false })
    })
  }

  handleGetStoryComments = () => {
    const { story, onGetStoryComments } = this.props
    return onGetStoryComments(story.id)
  }

  render () {
    const { story, userId } = this.props
    const { showComments, deleteStoryLoading } = this.state

    const likes = story.likes
    const comments = story.comments || {}
    const isFindFriends = story.object.subtype === 'find_friends'
    let actorImg = defaultImg

    if (story.actor.type !== 'site') {
      actorImg = `/profile/${story.actor.id}/picture?size=medium`
    }

    let privacyIconClass = null

    if (story.object.privacy && story.object.privacy !== 2) {
      privacyIconClass = `privacyIcon--${story.object.privacy}`
    }

    const userCanDelete = story.actor.id === userId && story.verb === 'post'

    return (
      <Row className={styles.container}>
        <Col xs={1} className={styles.actorImgCol}>
          <img className={styles.actorImg} src={actorImg} />
        </Col>
        <Col xs={12} sm={11}>
          <div className={styles.storyContainer}>
            <div className={styles.title}>
              <StoryTitle story={story} />
              {userCanDelete ?
                <div className={styles.deleteStoryContainer}>
                  {deleteStoryLoading ?
                    <Loader height={18} width={18} />
                  :
                    <Svg className={styles.deleteStory} name='x' onClick={this.handleDeleteStory} />
                  }
                </div>
              :
                <div className={styles.titleIcon}>
                  <img src={story.template.icon} />
                </div>
              }
            </div>
            <Row>
              {story.object.highlights && story.object.highlights.map((highlight, i) => {
                const numOfHighlights = story.object.highlights.length
                let value = story.object[highlight.key]
                value = typeof value === 'object' ? 0 : value
                return (
                  <Col className={styles.highlight} key={i} xs={12} sm={12 / numOfHighlights}>
                    <Highlight
                      highlight={highlight}
                      value={value}
                      numOfHighlights={numOfHighlights}
                    />
                  </Col>
                )
              })}
            </Row>
            {!isFindFriends ?
              <div className={styles.meta}>
                <div className={styles.likes}>
                  <Svg name='like' onClick={this.handleLikeClick} className={classnames(styles.metaIcon, {
                    [styles.likeActive]: likes && likes.replied,
                  })} />
                  {likes && likes.count ? <LikeCopy userId={userId} likes={likes} /> : 0}
                </div>
                <div className={styles.comments}>
                  <Svg name='comment' onClick={this.handleCommentClick} className={classnames(styles.metaIcon, {
                    [styles.commentsActive]: comments.count,
                  })} />
                  {comments && comments.count ? comments.count : 0}
                </div>
                <div className={styles.privacyTimeMeta}>
                  {privacyIconClass ?
                    <div className={classnames(styles.privacyIcon, styles[privacyIconClass])} />
                  : null}
                  <span className={styles.date}>
                    <RelativeDate date={story.published} />
                  </span>
                </div>
              </div>
            : null}
            {showComments ?
              <Comments
                comments={comments}
                userId={userId}
                onPostComment={this.handlePostComment}
                onDeleteComment={this.handleDeleteComment}
                onGetStoryComments={this.handleGetStoryComments}
              />
            : null}
          </div>
        </Col>
      </Row>
    )
  }
}

export default Story
